import type { ContainerAPI } from '@sbclite/core';

export const HEARTBEAT_MAX_AGE_MS = 120_000;

export function observeEngineHealth(container: { lastHeartbeat: string; status: string }, now: number) {
  const timestamp = Date.parse(container.lastHeartbeat);
  const fresh = Number.isFinite(timestamp) && timestamp <= now && now - timestamp < HEARTBEAT_MAX_AGE_MS;
  const heartbeatLabel = !Number.isFinite(timestamp) ? 'Unknown heartbeat' : timestamp > now ? 'Future heartbeat' : fresh ? 'Fresh heartbeat' : 'Stale heartbeat';
  return { fresh, observedHealthy: fresh && container.status === 'healthy', heartbeatLabel };
}

export function summarizeEngineHealth(containers: ContainerAPI.ListResponse['containers'], now: number) {
  const engines = containers.filter(container => container.serviceType === 'SipEngine').map(container => {
    return { ...container, ...observeEngineHealth(container, now) };
  });
  const healthy = engines.filter(engine => engine.observedHealthy).length;
  const status: 'offline' | 'critical' | 'warning' | 'healthy' = engines.length === 0 ? 'offline' : healthy === 0 ? 'critical' : healthy < engines.length ? 'warning' : 'healthy';
  return { engines, healthy, status };
}
